export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const CHECK_TOKEN_VALIDITY = 'CHECK_TOKEN_VALIDITY';
export const LOGOUT = 'LOGOUT';
export const IS_LOADING = 'IS_LOADING';